import type { InjectionKey } from 'vue'
import { provide, ref } from 'vue'

type LoadingCheck = (entity: LoadingAction) => boolean

export const loadingKey = Symbol() as InjectionKey<LoadingCheck>

export enum LoadingAction {
  Login = 'login',
  Signup = 'signup',
  EmailRecovery = 'email-recovery',
  PasswordUpdate = 'password-update',
}

export default function () {
  const loadingEntities = ref<LoadingAction[]>([])

  provide(loadingKey, isLoading)

  function isLoading(entity: LoadingAction, id?: string | number) {
    const entityName = id ? ((entity + `${id}`) as LoadingAction) : entity

    return loadingEntities.value.includes(entityName)
  }

  function toggleLoading(entity: LoadingAction, id?: string | number) {
    const entityName = id ? ((entity + `${id}`) as LoadingAction) : entity

    const entityIndex = loadingEntities.value.findIndex(
      (el) => el === entityName,
    )

    if (entityIndex > -1) {
      loadingEntities.value.splice(entityIndex, 1)
    } else {
      loadingEntities.value.push(entityName)
    }
  }

  return { isLoading, toggleLoading, LoadingAction }
}
